import { Currency, CurrencySettings } from '../types/currency'
import { getEffectiveLocale } from '../i18n'

export const APP_CURRENCIES = [
  'USD',
  'CAD',
  'EUR',
  'GBP',
  'JPY',
  'AUD',
  'CHF',
  'CNY',
  'INR',
  'BRL',
  'ZAR',
  'MXN',
  'SEK',
  'SGD',
  'NZD',
  'HKD',
  'NOK',
  'KRW',
  'TRY',
  'DKK',
  'AED',
  'SAR'
] as const

export const DEFAULT_STORE_CURRENCY = 'USD'

export const truncateCurrencyAmount = (value: number): number => {
  if (!Number.isFinite(value)) return 0
  return Math.round(value)
}

export const getCurrencySymbol = (locale: string, currency: string): string => {
  const formatted = (0).toLocaleString(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  })
  return String(formatted).replace(/\d/g, '').trim()
}

// countryCode/code pairs only -- symbol is locale-dependent (e.g. CAD renders as
// "CA$" in en-US but "$" in fr-CA) and must be resolved at call time via
// getSupportedCurrencies(), not baked in here, since ubDS.effectiveLocale can still
// be resolving asynchronously when this module first loads.
const CURRENCY_DEFS: ReadonlyArray<Omit<CurrencySettings, 'symbol'>> = [
  { countryCode: 'US', code: Currency.USD, rate: 1 },
  { countryCode: 'AU', code: Currency.AUD },
  { countryCode: 'CA', code: Currency.CAD },
  { countryCode: 'EU', code: Currency.EUR },
  { countryCode: 'GB', code: Currency.GBP },
  { countryCode: 'JP', code: Currency.JPY },
  { countryCode: 'CH', code: Currency.CHF },
  { countryCode: 'CN', code: Currency.CNY },
  { countryCode: 'IN', code: Currency.INR },
  { countryCode: 'BR', code: Currency.BRL },
  { countryCode: 'ZA', code: Currency.ZAR },
  { countryCode: 'MX', code: Currency.MXN },
  { countryCode: 'SE', code: Currency.SEK },
  { countryCode: 'SG', code: Currency.SGD },
  { countryCode: 'NZ', code: Currency.NZD },
  { countryCode: 'HK', code: Currency.HKD },
  { countryCode: 'NO', code: Currency.NOK },
  { countryCode: 'KR', code: Currency.KRW },
  { countryCode: 'TR', code: Currency.TRY },
  { countryCode: 'DK', code: Currency.DKK },
  { countryCode: 'AE', code: Currency.AED },
  { countryCode: 'SA', code: Currency.SAR }
]

//update CURRENCY_DEFS with the currencies in the enum Currency
export const getSupportedCurrencies = (locale: string = getEffectiveLocale()): CurrencySettings[] =>
  CURRENCY_DEFS.map(def => ({
    ...def,
    symbol: getCurrencySymbol(locale, def.code)
  }))
